import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form, Alert } from "react-bootstrap";
import Center from "react-center";
import Select from "react-select";
import * as Icons from "react-feather";
import moment from "moment";
import Axios from "axios";
import { urlAPI } from "Common";
import CanvasStep1 from "./CanvasStep1";

const initDataDokter = {
  count: 0,
  rows: [],
};
export default function Step2Page(props) {
  const {
    dataStep1,
    setDataStep1,
    selectorSBU,
    fetchSelectorUnit,
    selectorUnit,
    loadingUnit,
    dataStep2,
    setDataStep2,
    setMessageState,
    setShowFailed,
    setShowInfo,
    handleNext,
    setLoadingUnit,
    initStep2,
    dataBPJS,
    setDataBPJS,
    handlePrev,
    setUnitJenis3,
  } = props;

  const [dataDokter, setDataDokter] = useState(initDataDokter);
  const [loadingLoad, setLoadingLoad] = useState(false);

  const [openCanvas, setOpenCanvas] = useState(false);

  let hariIni = moment().format("YYYY-MM-DD");
  let maxHari =
    dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
      ? moment().add(30, "days").format("YYYY-MM-DD")
      : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
      ? moment().add(5, "days").format("YYYY-MM-DD")
      : moment().add(3, "days").format("YYYY-MM-DD");

  let hari_bpjs = dataStep1?.sbu === "RSPG" ? moment().add(2, "days").format("YYYY-MM-DD") : moment().add(3, "days").format("YYYY-MM-DD");

  const cekTanggalServer = () => {
    Axios.get(urlAPI + "/public/regonline/cektanggal")
      .then((response) => {
        // setTanggalServer(response?.data?.result[0]?.Tanggal);
        //setTanggalClient(moment(new Date()).format("YYYY-MM-DD"));

        if (
          moment(new Date()).format("YYYY-MM-DD") !==
          response?.data?.result[0]?.Tanggal
        ) {
          setMessageState("Tanggal Perangkat Tidak Sesuai Dengan Server");
          setShowFailed(true);
          setLoadingUnit(false);
        } else {
          // setLoadingPengumuman(true);
          // fetchCheckPengumuman();
          setLoadingLoad(true);
          setDataStep2(initStep2);
          fetchJadwalDokter();
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoadingUnit(false);
      });
  };

  const fetchJadwalDokter = () => {
    Axios.get(
      urlAPI +
        "/public/jadwaldokter/publictersedia?params=" +
        JSON.stringify({
          unit: dataStep1?.unit,
          day: moment(dataStep1?.date).day(),
          date: moment(dataStep1?.date).format("YYYY-MM-DD"),
          sbu: dataStep1?.sbu,
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          setDataDokter(response?.data?.result);
          setLoadingLoad(false);
        } else {
          setDataDokter(initDataDokter);
          setLoadingLoad(false);
        }
      })
      .catch((err) => {
        const message = err?.response?.message ?? err?.response?.data?.message;
        setMessageState(message);
        if (message === "No Data...") {
          setShowFailed(true);
        } else {
          setShowInfo(true);
        }
        setDataDokter(initDataDokter);
        setLoadingLoad(false);
      });
  };
  /*eslint-disable */
  useEffect(() => {
    if (
      dataStep1?.sbu !== null &&
      dataStep1?.unit !== null &&
      dataStep1?.date !== null &&
      moment(dataStep1.date).isValid()
    ) {
      setLoadingLoad(true);
      fetchJadwalDokter();
    }
  }, []);
  /*eslint-enable */
  //console.log('kodepolistep',dataStep2.kodeunitbpjs);
  return (
    <>
      <Card.Title>
        <strong>(2/4) Pilih Dokter dan Jam</strong>
      </Card.Title>
      <br />
      <div className="d-grid gap-2 d-block d-md-none">
        <Button
          block
          variant="warning"
          disabled={
            dataStep1?.sbu === null ||
            dataStep1?.unit === null ||
            dataStep1?.date === null ||
            moment(dataStep1.date).isValid() === false ||
            loadingLoad
          }
          onClick={() => {
            setOpenCanvas(true);
          }}
        >
          {loadingLoad ? "Loading..." : "Ubah Tujuan dan Tanggal"}
        </Button>
      </div>
      <Card className="d-none d-md-block">
        <Card.Body>
          <Form>
            <Row>
              <Col lg="3" md="6">
                <Form.Group className="mb-3">
                  <Form.Label>Rumah Sakit / Klinik Tujuan</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="sbu"
                    name="sbu"
                    options={selectorSBU}
                    isDisabled={loadingLoad}
                    value={selectorSBU.find(
                      (find) => find?.value === dataStep1?.sbu
                    )}
                    onChange={(e) => {
                      fetchSelectorUnit(e.value);
                      setDataStep1({
                        ...dataStep1,
                        sbu: e.value,
                        sbuname: e.label,
                        unit: null,
                        unitname: null,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col lg="3" md="6">
                <Form.Group className="mb-3">
                  <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
                  {dataStep1?.sbu !== null ? (
                    <Select
                      styles={{
                        color: "black",
                      }}
                      id="unit"
                      name="unit"
                      options={selectorUnit}
                      isDisabled={loadingLoad}
                      isLoading={loadingUnit}
                      value={selectorUnit.find(
                        (find) => find?.value === dataStep1?.unit
                      )}
                      onChange={(e) => {
                        setDataStep1({
                          ...dataStep1,
                          unit: e.value,
                          unitname: e.label,
                        });
                        setUnitJenis3(e.jenis3);
                      }}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      value="Pilih Rumah Sakit / Klinik Tujuan Terlebih Dahulu..."
                      disabled
                    />
                  )}
                </Form.Group>
              </Col>
              <Col lg="3" md="6">
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal</Form.Label>
                  <Form.Control
                    type="date"
                    id="tanggal"
                    name="tanggal"
                    value={dataStep1?.date}
                    onChange={(e) => {
                      setDataStep1({ ...dataStep1, date: e.target.value });
                      // cekTanggalServer();
                    }}
                    min={moment().add(0, "days").format("YYYY-MM-DD")}
                    max={
                      dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
                        ? moment().add(30, "days").format("YYYY-MM-DD")
                        : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
                        ? moment().add(5, "days").format("YYYY-MM-DD")
                        : moment().add(3, "days").format("YYYY-MM-DD")
                    }
                    // disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="3" md="6">
                <div className="d-grid gap-2" style={{ paddingTop: "32px" }}>
                  <Button
                    block
                    variant="warning"
                    disabled={
                      dataStep1?.sbu === null ||
                      dataStep1?.unit === null ||
                      dataStep1?.date === null ||
                      dataStep1?.date < hariIni ||
                      dataStep1?.date > maxHari ||
                      moment(dataStep1.date).isValid() === false ||
                      loadingLoad
                    }
                    onClick={() => {
                      cekTanggalServer();
                    }}
                  >
                    {
                      dataStep1?.date < hariIni ||
                      dataStep1?.date > maxHari
                        ? "Tanggal Tidak Valid"
                        : loadingLoad
                        ? "Loading..."
                        : "Cari"
                    }
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      {loadingLoad ? (
        <>
          <br />
          <Center>
            <h3>Loading...</h3>
          </Center>
        </>
      ) : (
        <>
          {dataStep1?.sbu === "RSPG" && (dataStep1?.date === hariIni || dataStep1?.date > hari_bpjs) ? <p>Pilihan tanggal tersebut tidak tersedia untuk pasien BPJS, bisa menggunakan Aplikasi Mobile JKN untuk dapat mendaftar di hari tersebut </p> : <></>}
          {dataDokter?.rows?.length > 0 ? (
            <Row className="g-4">
              {dataDokter?.rows?.map((obj, index) => (
                <Col
                  lg="3"
                  md="6"
                  sm="12"
                  key={index}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Card
                    style={{
                      width: "100%",
                      maxWidth: "300px",
                      boxShadow:
                        "0 14px 14px 0 rgba(0,0,0,.25), 0 10px 5px 0 rgba(0,0,0,.22)",
                      border: "none",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Card.Img
                      variant="top"
                      src={
                        "/assets/img/doctor/" +
                        obj?.kodedokter.trim() +
                        ".webp"
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src =
                          "/assets/img/doctor/default-doctor.svg";
                      }}
                    />
                    <Card.Body>
                      <Card.Title
                        style={{
                          minHeight: "50px",
                          textAlign: "center",
                        }}
                      >
                        {obj?.namadokter}
                      </Card.Title>
                      <Card.Text>
                        <p
                          style={{
                            color: "#33691E",
                            paddingTop: "10px",
                            paddingBottom: 0,
                            textAlign: "center",
                          }}
                        >
                          <Icons.Clock size={18} />
                          <strong> {obj?.jam}</strong>
                        </p>
                        <p style={{ textAlign: "center" }}>
                          <Icons.Home size={18} />
                          <strong> {obj?.ruang}</strong>
                        </p>
                      </Card.Text>
                    </Card.Body>
                    <div
                      className="d-grid gap-2"
                      style={{ padding: "10px" }}
                    >
                      <Button
                        variant="primary"
                        onClick={(e) => {
                          setDataStep2({
                            ...dataStep2,
                            idjadwal: obj?.id,
                            kodedokter: obj?.kodedokter,
                            namadokter: obj?.namadokter,
                            kodedokterbpjs: obj?.kodedokterbpjs,
                            kodeunitbpjs: obj?.kodeunitbpjs,
                            ruang: obj?.ruang,
                            jam: obj?.jam,
                          });
                          setDataBPJS({
                            ...dataBPJS,
                            kodedokterbpjs: obj?.kodedokterbpjs,
                            kodeunitbpjs: obj?.kodeunitbpjs,
                            kuota: obj?.kuota,
                          });
                          handleNext();
                        }}
                        disabled={
                          parseInt(obj?.kuota) !== 0 &&
                          parseInt(obj?.totalantrian) >=
                            parseInt(obj?.kuota)
                        }
                      >
                        {parseInt(obj?.kuota) !== 0 &&
                        parseInt(obj?.totalantrian) >=
                          parseInt(obj?.kuota)
                          ? "Kuota Penuh"
                          : "Pilih"}
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <>
              <br />
              <Center>
                <img src="assets/img/empty-1.svg" width="30%" alt="gambar" />
              </Center>
              <br />
              <p style={{ textAlign: "center" }}>
                Tidak ada Dokter yang Tersedia, Mohon Mencoba Ditanggal yang
                Lain...
              </p>
            </>
          )}
        </>
      )}
      <br />
      <Button
        style={{ float: "left" }}
        variant="secondary"
        disabled={loadingLoad}
        onClick={() => {
          handlePrev();
        }}
      >
        <Icons.ArrowLeft size={18} />
        Kembali Pilih Dokter
      </Button>
      {/* Mobile Canvas */}
      <CanvasStep1
        dataStep1={dataStep1}
        setDataStep1={setDataStep1}
        selectorSBU={selectorSBU}
        fetchSelectorUnit={(event) => {
          setLoadingUnit(true);
          fetchSelectorUnit(event);
        }}
        selectorUnit={selectorUnit}
        loadingUnit={loadingUnit}
        openCanvas={openCanvas}
        setOpenCanvas={setOpenCanvas}
        fetchJadwalDokter={fetchJadwalDokter}
        setLoadingLoad={setLoadingLoad}
        setDataStep2={setDataStep2}
        initStep2={initStep2}
        setUnitJenis3={setUnitJenis3}
      />
    </>
  );
}
